// Semantic palette shared across status pills, badges and indicators
export const STATUS_COLORS = {
  GREEN:  { bg: '#e8f5e9', color: '#2e7d32', dot: '#4caf50' },
  RED:    { bg: '#ffebee', color: '#c62828', dot: '#f44336' },
  YELLOW: { bg: '#fff8e1', color: '#f57f17', dot: '#ffc107' },
  GREY:   { bg: '#f5f5f5', color: '#757575', dot: '#9e9e9e' },
  ORANGE: { bg: '#fff3e0', color: '#e65100' },
  BLUE:   { bg: '#e3f2fd', color: '#1565c0' },
}
